import { render, staticRenderFns } from "./gutter-editor.vue?vue&type=template&id=160353ff&scoped=true"
import script from "./gutter-editor.vue?vue&type=script&lang=js"
export * from "./gutter-editor.vue?vue&type=script&lang=js"
import style0 from "./gutter-editor.vue?vue&type=style&index=0&id=160353ff&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160353ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('160353ff')) {
      api.createRecord('160353ff', component.options)
    } else {
      api.reload('160353ff', component.options)
    }
    module.hot.accept("./gutter-editor.vue?vue&type=template&id=160353ff&scoped=true", function () {
      api.rerender('160353ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/container-grid/gutter-editor.vue"
export default component.exports